export function proofNumbersSlider() {
    let $sliderConntainer = $(".proof-numbers-slider");
    let $sliders = $sliderConntainer.find(".proof-numbers-row");

    $sliders.each(function (index, slider) {
        $(slider).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 0,
            speed: 20000,
            mobileFirst: true,
            arrows: false,
            dots: false,
            cssEase:"linear",
            centerMode: true,
            variableWidth: true
        });
    });
};


// WEBPACK FOOTER //
// ./assets/js/modules/proofNumbersSlider.js